
// eslint-disable-next-line
export const maxInfluencerLimit = 'You have reached the max limit of influencers allowed on a list for your plan type.';
export const maxListLimit = 'You have reached the max limit of lists allowed for your plan type.';
export const maxReportLimit = 'You have reached the max limit of reports allowed for your plan type.';
export const maxSearchLimit = 'You have reached the maximum searches allowed for your plan type.';
